import styled from "styled-components";
import { Link } from "react-router-dom";

import heartXLogo from "../assets/logos/heart-x.png";

const Container = styled.div`
  cursor: pointer;
`;

const StyledLogo = styled.img`
  position: relative;
  height: 3.9rem;
  width: auto;
  display: block;
  margin-top: 0;

  @media only screen and (max-width: 750px) {
    height: 3.4rem;
  }
`;

const Logo = () => {
  return (
    <Container>
      <Link to="/" aria-label="Killer GF home">
        <StyledLogo src={heartXLogo} alt="Killer GF" width="336" height="135" />
      </Link>
    </Container>
  );
};

export default Logo;
